export { Paragraph } from './paragraph';
export { bodyLarge, bodyMedium, bodySmall } from './styled';
